import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { orderArrayByStringProperty } from "../../../util/arraysUtil";
import "./AdminPatientList.css";
import Container from "../../../ui/Container/Container";
import List from "../../../ui/List/List";

function AdminPatientsList() {
  const location = useLocation();
  const paramPatients = location.state.data;
  const doctor = location.state.doctor;
  const [searchQuery, setSearchQuery] = useState("");
  const [allPatients, setAllPatients] = useState(paramPatients);
  const [patients, setPatients] = useState(paramPatients);

  function handleSearch(e) {
    const query = e.target.value;
    setSearchQuery(query);
    const formattedQuery = query.toLowerCase();
    const filteredData = allPatients.filter((patient) => {
      const fullItem = `${patient.patientInitials}: ${patient.patientName}`;
      return fullItem.toLowerCase().includes(formattedQuery);
    });
    setPatients(filteredData);
  }

  function generateData() {
    let patientsList = patients.map((patient) => {
      return {
        key: patient.key,
        value: patient.patientName,
        navigateTo: "/adminPatientInfo",
        route: { data: patient, patients: paramPatients, doctor },
      };
    });
    patientsList = orderArrayByStringProperty(patientsList, "value");
    return patientsList;
  }

  return (
    <Container
      title={"Pacientes"}
      backNavigation={"/doctorInfo"}
      route={{ doctor }}
    >
      <div className="innerContainer">
        <input
          placeholder="Buscar paciente..."
          className="filter"
          autoCapitalize="none"
          onChange={handleSearch}
        />

        <List data={generateData()} height="80%" />
      </div>
    </Container>
  );
}

export default AdminPatientsList;
